import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=76d1dc41&"
import script from "./VideoList.vue?vue&type=script&lang=js&"
export * from "./VideoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoCard: require('/usr/src/app/components/video/VideoCard.vue').default,CardLoading: require('/usr/src/app/components/common/CardLoading.vue').default})
